export class Record {
  post_id:any;
  id:string;
  attach_id:string;
  url:string;
  name:string;
  description:string;
  showTitle:Boolean;

  constructor(post_id:any, id:string, attach_id:string, url:string, name?:string, description?:string, showTitle?:Boolean) {
    this.post_id = post_id;
    this.id = id;
    this.attach_id = attach_id;
    this.url = url;
    this.name = name;
    this.description = description;
    this.showTitle = showTitle;
  }
}



// WEBPACK FOOTER //
// ./admin/src/app/components/record-item/record-item.model.ts